function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Given an object containing a bunch of keys, this returns an array of values for all the keys that start with the
 * string defined in `startsWith` param
 *
 * For example, suppose you have an object holding a bunch of constants, like so:
 *
 *    const EDITOR_TAGS = { HTML_DIV: 'div', HTML_SPAN: 'span', CUSTOM_SLIDER: 'slider'  }
 *
 * Calling `getConstantsByPrefix(EDITOR_TAGS, 'HTML_')` would return:
 *
 *    ['div', 'span']
 *
 * @param {Object} constantsObject
 * @param {string} startsWith
 *
 * @return {Array<string>}
 */
var getConstantsByPrefix = function getConstantsByPrefix(constantsObject, startsWith) {
  return Object.entries(constantsObject).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    return name.startsWith(startsWith);
  }).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        constName = _ref4[0],
        constValue = _ref4[1];

    acc.push(constValue);
    return acc;
  }, []);
};

export { getConstantsByPrefix };